import React from 'react';
import { useNavigate } from 'react-router-dom';
import GoalsMainPage from './GoalsMainPage';

const GoalsMainPageWrapper = () => {
  const navigate = useNavigate();
  
  return (
    <GoalsMainPage 
      navigate={navigate}
    />
  );
};

export default GoalsMainPageWrapper;
